package api.service.propertyOwners

import api.data.DataPropertyOwner
import api.data.toDataPropertyOwner
import dev.gitlive.firebase.firestore.Direction
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import firebaseFirestore

class ImplServicePropertyOwners : ServicePropertyOwners{
    override suspend fun getPropertyOwners(): ArrayList<DataPropertyOwner>? {
        val listOwners: ArrayList<DataPropertyOwner>? = ArrayList<DataPropertyOwner>()
        try {
            firebaseFirestore.collection("PropertyOwners").orderBy("timestamp", Direction.ASCENDING)
                .get().documents.forEach {documentSnapshot ->
                    if (documentSnapshot.exists){
                       listOwners?.add(documentSnapshot.toDataPropertyOwner())
                    } else {
                        return null
                    }
                }
        } catch (e: FirebaseFirestoreException){
            throw e
        }
        return listOwners
    }
}